import { Chart, registerables } from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'
import { BoxPlotController, BoxAndWiskers } from '@sgratzl/chartjs-chart-boxplot'
import { toFont } from 'chart.js/helpers'
import 'chartjs-adapter-moment'
import { chartjsTitleProperties } from '../Constants'

export const centerTextPlugin = {
  id: 'centerText',
  beforeDraw: (chart, _args, options) => {
    const text = options?.text
    if (text === null || text === undefined) return

    const { ctx, chartArea } = chart
    const centerX = (chartArea.left + chartArea.right) / 2
    const centerY = (chartArea.top + chartArea.bottom) / 2

    ctx.save()
    ctx.font = toFont(options.font).string
    ctx.fillStyle = options.color ?? Chart.defaults.color
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillText(text, centerX, centerY)
    ctx.restore()
  },
  defaults: {
    text: null
  }
}

Chart.register(...registerables, annotationPlugin, BoxPlotController, BoxAndWiskers, centerTextPlugin)

Chart.defaults.datasets.line.tension = 0.4

if (typeof document !== 'undefined' && document.fonts) {
  document.fonts.load(toFont(chartjsTitleProperties.font).string).then(() => {
    Object.values(Chart.instances).forEach((chart) => chart.update('none'))
  })
}

export default Chart
